import { connect } from 'react-redux';
import Component from './component';
import {
    addFavouriteOrg,
    fetchOrgs,
    filterOrg,
    getAllOrg,
    getUnselectedAllOrg,
    handleOrgRequestClose,
    hideOrgLoader,
    showOrgLoader,
    onAddOrg,
    onAllOrgSelect,
    onOrgClose,
    onOrgSelect,
    onDeleteOrg,
    onDeleteSelectedOrg,
    onFilterOrgOptionSelect,
    onSaveOrg,
    onToggleOrgDrawer,
    updateSearchOrg,
    onEmpDashboard,
    onOrgSurveyDashboard,
    onProjectDashboard,
    onImpersonateOrg
} from 'actions/Organisation';
import { clearSelectedObjects } from 'actions/session';


const mapStateToProps = ({ orgs, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        org,
        searchOrg,
        filterOption,
        allOrg,
        orgList,
        selectedOrg,
        selectedOrgs,
        addOrgState
    } = orgs;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        org,
        searchOrg,
        filterOption,
        allOrg,
        orgList,
        selectedOrg,
        selectedOrgs,
        addOrgState
    };
};
export default connect(mapStateToProps, {
    fetchOrgs,
    addFavouriteOrg,
    onOrgSelect,
    onAddOrg,
    onOrgClose,
    onFilterOrgOptionSelect,
    onSaveOrg,
    onDeleteOrg,
    onDeleteSelectedOrg,
    filterOrg,
    getAllOrg,
    getUnselectedAllOrg,
    onAllOrgSelect,
    updateSearchOrg,
    onToggleOrgDrawer,
    handleOrgRequestClose,
    hideOrgLoader,
    showOrgLoader,
    onEmpDashboard,
    onOrgSurveyDashboard,
    onProjectDashboard,
    onImpersonateOrg,
    clearSelectedObjects
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/organisation/container.js